<template>
  <div>
    <LoadingSpinner
      v-show="loading"
      :loading="loading"
      :text="loadingSpinnerText"
    />
    <b-form v-show="!loading" @submit.prevent="submit">
      <b-row>
        <b-col>
          <b-alert show variant="danger">
            کلیه درخواست‌های انتخابی طبق فیلتر انجام شده به وضعیت خاتمه یافته
            تغییر خواهند کرد انتخاب فیلتر الزامی است و انجام این فعالیت بدون
            اعمال محدودیت امکان ندارد. لطفا در انجام این عملیات دقت نمائید چون
            فرایند صورت گرفته غیر قابل برگشت خواهد بود و کلیه درخواست‌ها با متن
            پیام نوشته شده خاتمه خواهند یافت.
          </b-alert>
        </b-col>
        <b-col cols="12">
          <b-form-group :label="$lang.ticketLang.text_message" :label-cols="12">
            <requiredComponent
              :label="$lang.ticketLang.text_message"
              slot="label"
              :rules="$v.description.$params"
            />
            <b-form-textarea
              id="description"
              v-model="$v.description.$model"
              type="text"
              :rows="4"
              :state="$v.description.$dirty ? !$v.description.$error : null"
            >
            </b-form-textarea>
            <b-form-invalid-feedback id="description-feedback">
              {{
                $lang.error_required.replace(
                  "{0}",
                  $lang.ticketLang.text_message
                )
              }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          class="text-right mt-3"
          v-if="isAdmin(parentPermissions, ['admin'])"
        >
          <b-button type="submit" variant="success">
            {{ $lang.submitButton }}
            <i class="fa fa-check"></i>
          </b-button>
          <b-button
            type="reset"
            class="ml-2"
            size="md"
            variant="danger"
            @click="close"
          >
            {{ $lang.close }}
            <i class="fa fa-ban"></i>
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { required } from "vuelidate/lib/validators";
import { isAdmin } from "@/shared/utils";

export default {
  inject: ["allticketRepository"],
  validations: {
    description: {
      required,
    },
  },
  components: {
    LoadingSpinner,
  },
  data() {
    return {
      loading: false,
      loadingSpinnerText: this.$lang.search.loading_send,
      parentPermissions: ["admin"],
      description: null,
    };
  },
  methods: {
    isAdmin,
    close() {
      this.$emit("close");
    },
    async submit() {
      try {
        this.loading = true;
        this.$v.$touch();
        if (this.$v.$anyError) {
          return;
        }
        let payload = {
          message: this.description,
        };
        const response = await this.allticketRepository.partial_edit(payload);
        this.$notify.success(response.data.message);
        this.$emit("getItems");
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style></style>
